import type { ReactNode } from "react";

interface ScreenShellProps {
  readonly title?: string;
  readonly subtext?: string;
  readonly children: ReactNode;
  readonly footer?: ReactNode;
  readonly center?: boolean;
}

/**
 * Shared vertical rhythm for every onboarding screen: headline block on top,
 * flexible content, and a footer (CTA) pinned toward the bottom safe area.
 */
export function ScreenShell({ title, subtext, children, footer, center = false }: ScreenShellProps) {
  return (
    <div className="flex flex-1 flex-col">
      <div
        className={`flex min-h-0 flex-1 flex-col ${center ? "justify-center" : ""} gap-4 py-4`}
      >
        {(title || subtext) && (
          <div className="flex flex-col gap-2">
            {title && <h1 className="text-2xl font-bold text-text">{title}</h1>}
            {subtext && <p className="text-sm text-text-muted">{subtext}</p>}
          </div>
        )}
        {children}
      </div>
      {footer && (
        <div className="flex flex-col gap-3 pb-[max(env(safe-area-inset-bottom),1.5rem)] pt-2">
          {footer}
        </div>
      )}
    </div>
  );
}
